import { HTMLAttributes, useEffect, useState } from 'react'

import { Button, Text, theme } from '@hhgtech/hhg-components'
import { Badge, Carousel } from '@hhgtech/hhg-components/mantine'
import { useIntl } from 'react-intl'

import { useCurrentUrl } from 'hooks/useCurrentUrl'
import { CategoryKeyword } from 'interfaces/types/Keyword'

import { StyledKeywordContainer } from './index.styled'

type KeywordContainerProps = {
  keywords: Array<CategoryKeyword>
  onKeywordChange(id: number): void
} & HTMLAttributes<HTMLDivElement>
export const KeywordContainer = ({
  keywords,
  onKeywordChange,
  ...rest
}: KeywordContainerProps) => {
  const { formatMessage: f } = useIntl()
  const [selectedKeyword, setSelectedKeyword] = useState(-1)
  const currentUrl = useCurrentUrl()
  useEffect(() => {
    if (keywords.find((k) => k.termId === -1)) return
    keywords.unshift({
      termId: -1,
      name: f({ id: 'keyword.all', defaultMessage: 'All' }),
    } as CategoryKeyword)
  }, [keywords])

  const onSelectKeyword = (id: number) => {
    setSelectedKeyword(id)
    onKeywordChange(id)
  }

  return (
    <StyledKeywordContainer {...rest}>
      <Carousel
        align="start"
        slideGap="md"
        dragFree
        // withControls={false}
        slideSize="10%"
        controlsOffset={-26}
      >
        {keywords.map((keyword) => (
          <Carousel.Slide key={keyword.termId}>
            <Badge
              color="#ffffff"
              size="lg"
              styles={{
                root: {
                  backgroundColor:
                    selectedKeyword === keyword.termId
                      ? theme.colors.primaryBase
                      : theme.colors.neutral50,
                  borderRadius: '40px',
                  textTransform: 'unset',
                },
              }}
            >
              <Button
                color="transparent"
                size="sm"
                onClick={() => onSelectKeyword(keyword.termId)}
                data-event-category="Category Tag"
                data-event-action="Click"
                data-event-label={currentUrl}
                className="pointer-event-child-none"
              >
                <Text
                  size="s4"
                  type="semiBold"
                  color={
                    selectedKeyword === keyword.termId
                      ? '#ffffff'
                      : theme.colors.gray600
                  }
                >
                  {keyword.name}
                </Text>
              </Button>
            </Badge>
          </Carousel.Slide>
        ))}
      </Carousel>
    </StyledKeywordContainer>
  )
}
